import type React from 'react';

const HighwayIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg
    width="17"
    height="12"
    viewBox="0 0 17 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M7.8625 12V10.2857C7.8625 9.93429 8.1515 9.64286 8.5 9.64286C8.8485 9.64286 9.1375 9.93429 9.1375 10.2857V12H17L11.9 0H9.1375V1.71429C9.1375 2.06571 8.8485 2.35714 8.5 2.35714C8.1515 2.35714 7.8625 2.06571 7.8625 1.71429V0H5.1L0 12H7.8625ZM7.8625 5.14286C7.8625 4.79143 8.1515 4.5 8.5 4.5C8.8485 4.5 9.1375 4.79143 9.1375 5.14286V6.85714C9.1375 7.20857 8.8485 7.5 8.5 7.5C8.1515 7.5 7.8625 7.20857 7.8625 6.85714V5.14286Z"
      fill="white"
    />
  </svg>
);

export default HighwayIcon;
